import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneFileService } from '../../../../projects/kiene-core/src/lib/services/files/kiene-file.service';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { NumberTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { Primanota } from './primanota';

@Component({
    selector: 'kiene-primanota',
    templateUrl: './primanota.component.html',
    styleUrls: ['./primanota.component.css'],
})
export class PrimanotaComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private fileService: KieneFileService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = 'Primanotas';
        this.tableDescriptor.uniqueIdentifier = 'Primanotas';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'primanota/';
        this.tableDescriptor.route = '/finanzen/primanota/';
        this.tableDescriptor.nameOfIdField = 'primanota_id';
        this.tableDescriptor.searchPlaceholder = 'Primanotas durchsuchen';
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.initialSortColumn = 'primanota_id';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.permissionView = 2971;

        this.tableDescriptor.columns.push(new TableColumn('primanota_id', 'ID'));
        this.tableDescriptor.columns.push(new TableColumn('dateiname', 'Dateiname'));
        this.tableDescriptor.columns.push(new TableColumn('status', 'Status'));
        this.tableDescriptor.columns.push(new TableColumn('jahr', 'Jahr'));
        this.tableDescriptor.columns.push(new TableColumn('monat', 'Monat'));
        this.tableDescriptor.columns.push(new NumberTableColumn('anzahl', 'Positionen', '1.0-0'));
        if (this.localStorageService.hasPermission(1608)) {
            this.tableDescriptor.columns.push(new NumberTableColumn('umsatz_brutto', 'Umsatz Brutto (Euro)'));
        }
        this.tableDescriptor.columns.push(new TableColumn('erstellt', 'erstellt', 'date'));
        this.tableDescriptor.columns.push(new TableColumn('nachname', 'erstellt von'));

        this.tableDescriptor.options.push(
            new TableOption(this.downloadPrimanota.bind(this), 'Primanota Download', 'cloud_download', 2951),
        );
    }

    downloadPrimanota(primanota: Primanota) {
        const params = new HttpParams().append('primanota_id', primanota?.primanota_id?.toString());
        this.fileService.downloadCSV(this.apiBaseUrl + 'primanota/read_csv.php', params);
    }
}
